
import { defineComponent, ref } from 'vue'
import ApText from './ApText.vue'
import ApTsla from './ApTsla.vue'
import ApTcommentHistory from './ApCommentHistory.vue'
import TravelText from './TravelText.vue'
import TravelTsla from './TravelTsla.vue'
import PcText from './PcText.vue'
import PcTsla from './PcTsla.vue'

export default defineComponent({
    components: {
        ApText,
        ApTsla,
        ApTcommentHistory,
        TravelText,
        TravelTsla,
        PcText,
        PcTsla
    },
    setup(){
        const name = ref('IBPS Transaction')
        
        return {
            name,
        }
    }
});

